module.exports = __webpack_public_path__ + "static/media/divider.bd6afee2.svg";